import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturedProviders from "./components/FeaturedProviders";
import { CategoryNavSection, HowItWorksSection, ReviewSection, CtaSection, NewsSection, FeaturedCategories, AnnouncementBanner, FreeSamplesSection } from "./components/HomeSections";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main className="pt-16">
        <AnnouncementBanner />
        <HeroSection />
        <CategoryNavSection />
        <FreeSamplesSection />
        <FeaturedProviders />
        <FeaturedCategories />
        <HowItWorksSection />
        <ReviewSection />
        <CtaSection />
        <NewsSection />
      </main>
      <Footer />
    </div>
  );
}
